import { Component } from '@angular/core';
import {AlertController, IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {RegisterPage} from "../register/register";
import {LoginPage} from "../login/login";

/**
 * Generated class for the IntroDescriptionPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-intro-description',
  templateUrl: 'intro-description.html',
})
export class IntroDescriptionPage {
  loginPage: any = LoginPage;

  constructor(public navCtrl: NavController, public navParams: NavParams, public alertCtrl: AlertController, public contentTranslation: ContentTranslationProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad IntroDescriptionPage');
  }

  showMoreInfo() {
    const alert = this.alertCtrl.create({
      title: this.contentTranslation.translateContent('Registration Program Description Modal Explain Title'),
      subTitle: this.contentTranslation.translateContent('Registration Program Description Modal Explain Text'),
      buttons: [
        {
          text: 'OK',
        },
        {
          text: '×',
          cssClass: 'close-button'
        }
      ],
      cssClass: 'ip-alert ip-with-close'
    });
    alert.present();

  }

  nextStep() {
    this.navCtrl.push(RegisterPage)
  }

}



// WEBPACK FOOTER //
// ./src/pages/intro-description/intro-description.ts